import * as React from 'react';
import { connect } from 'react-redux';

import {
  ISubscriptionsSectionDispatchProps,
  ISubscriptionsSectionOwnProps,
  ISubscriptionsSectionProps,
  ISubscriptionsSectionStoreProps,
  SubscriptionsSection,
} from '.';
import { IAppState, TThunkDispatch } from '../../../store';
import { changeActiveScreen, TActiveScreen } from '../../../store/activeScreen';
import { removeFailedAction } from '../../../store/failedAction';
import { getSubscriptionsList, setTitleSubscribedOn } from '../../../store/subscriptions';
import { Notice } from '../../base/Notice';

function mapStateToProps(state: IAppState): ISubscriptionsSectionStoreProps {
  const { subscriptions, failedAction } = state;

  return {
    failedAction,
    status: subscriptions.status,
    subscriptions: subscriptions.data,
    titleSubscribedOn: subscriptions.titleSubscribedOn,
    modalSubscribedOn: null,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): ISubscriptionsSectionDispatchProps {
  return {
    changeActiveScreen: (activeScreen: TActiveScreen) => dispatch(changeActiveScreen(activeScreen)),
    getSubscriptionList: (categoryName: string, offset: number) =>
      dispatch(getSubscriptionsList({ categoryName, offset })),
    removeFailedAction: () => dispatch(removeFailedAction()),
    closeModalSubscribedOn: () => dispatch(setTitleSubscribedOn('')),
  };
}

function mergeProps(
  stateProps: ISubscriptionsSectionStoreProps,
  dispatchProps: ISubscriptionsSectionDispatchProps,
  ownProps: ISubscriptionsSectionOwnProps,
): ISubscriptionsSectionProps {
  const { closeModalSubscribedOn } = dispatchProps;
  const { titleSubscribedOn } = stateProps;

  const modalSubscribedOn = titleSubscribedOn && (
    <Notice onClose={closeModalSubscribedOn}>{`Отлично! Вы подписаны на тематику «${titleSubscribedOn}»`}</Notice>
  );

  return {
    ...dispatchProps,
    ...stateProps,
    ...ownProps,
    modalSubscribedOn,
  };
}

export const SubscriptionsSectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SubscriptionsSection);
